import { FormArray, FormGroup, UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { UploadApiService } from 'src/app/services/uploadapi.service';
import { ManagementApiService, UserUtilityService } from 'src/app/services';
import { UploadHistory } from '../../models/idms/data-upload.model';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
@Component({
    selector: 'app-data-uploads',
    templateUrl: './data-uploads.component.html',
    styleUrls: ['./data-uploads.component.scss'],
    standalone: false
})
export class DataUploadsComponent {
    @Input() idmsFormGroup: UntypedFormGroup;
    tooltip_position = 'above';
    menuData: any;
    uploadHistory: UploadHistory[];
    createdataUpload: boolean;
    constructor(
        private modalService: NgbModal,
        private ngxUiLoaderService: NgxUiLoaderService,
        private uploadApiService: UploadApiService,
        private managementApiService: ManagementApiService,
        private cd: ChangeDetectorRef,
        private userUtilityServices: UserUtilityService
    ) {}

    async ngOnInit(): Promise<void> {
        this.createdataUpload = await this.userUtilityServices.checkUserPermissionDataAndRoute('settings-iDMS-dataUploads', userActions.Create);
        if (this.createdataUpload) this.getdownloadmenu();
        this.getUploadedHistory();
    }

    open1(content) {
        this.modalService
            .open(content, {
                ariaLabelledBy: 'modal-basic-title',
                backdrop: 'static',
                size: 'lg',
                keyboard: false,
            })
            .result.then(
                (result) => {
                    // this.closeResult = `Closed with: ${result}`;
                },
                (reason) => {
                    // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
                }
            );
    }
    getdownloadmenu() {
        this.ngxUiLoaderService.start();
        this.uploadApiService.getdownloadmenu().subscribe(
            (instances) => {
                this.ngxUiLoaderService.stop();
                if (instances.success === true) {
                    this.menuData = instances.response;
                    this.cd.detectChanges();
                } else {
                    this.userUtilityServices.errorModelPopup(instances.message);
                }
            },
            (error) => {
                this.ngxUiLoaderService.stop();
                // TODO :show error toast with message "Error while getting the instances"
            }
        );
    }

    getUploadedHistory() {
        this.ngxUiLoaderService.start();
        this.managementApiService.getUploadHistory().subscribe(
            (instances) => {
                this.ngxUiLoaderService.stop();
                if (instances.success === true) {
                    this.uploadHistory = instances.response;
                    this.cd.detectChanges();
                } else {
                    this.userUtilityServices.errorModelPopup(instances.message);
                }
            },
            (error) => {
                this.ngxUiLoaderService.stop();
                // TODO :show error toast with message "Error while getting the instances"
            }
        );
    }

    reloadUploadHostory(value: any): void {
        if (value) this.getUploadedHistory();
    }
}
